/*
 * @Description: 图片选择上传（支持多张）
 * @Author: oubu
 * @Date: 2020-04-21
 */
import React, { Component } from 'react';
import { Flex, ImagePicker, Toast } from 'antd-mobile';
import Upload from 'utils/upload';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './index.less';

export default class ImagePickerView extends Component {
  static propTypes = {
    //  // 最多上传多少张
    maxLength: PropTypes.number,
    title: PropTypes.string,
    onChange: PropTypes.func,
    isPrivate: PropTypes.bool
  };

  static defaultProps = {
    maxLength: 1,
    title: '',
    onChange: () => {},
    isPrivate: false
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      imgList: this.props.initialImgList || [],
      enlargePic: false, // 是否放大图片
      src: '' // 放大图片源
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.initialImgList[0] !== prevState.imgList[0]) {
      return {
        imgList: nextProps.initialImgList
      };
    }

    return null;
  }

  /**
   * type: 添加add, 移除remove
   * index: 移除的索引
   */
  onChange = (files, type, index) => {
    console.log(9000);
    const { maxLength, isPrivate } = this.props;
    if (type == 'add') {
      const { file } = files[files.length - 1];
      if (!file) {
        return Toast.info('请选择一张图片');
      }

      Toast.loading('上传中,请稍后', 100);
      console.log(10000, isPrivate);
      Upload.uploadObject2OSS({ file, scene: this.props.scene || 'personinfo-document' })
        .then((res) => {
          Toast.hide();
          if (res) {
            const { imgList } = this.state;
            if (imgList.length == maxLength) {
              imgList.pop();
            }
            imgList.push(res);
            this.setState({ imgList });
            this.props.onChange(imgList);
          } else {
            Toast.info('上传失败，请重新上传');
          }
        })
        .catch((err) => {
          Toast.info(err.message || '上传失败，请重新上传');
        });
    }
  };

  /**
   * 删除
   */
  onDelete = (index) => {
    const { imgList } = this.state;
    imgList.splice(index, 1);
    this.setState({ imgList });
    this.props.onChange(imgList);
  };

  /**
   * 查看大图
   */
  lookPic = (pic) => {
    this.setState({
      src: pic,
      enlargePic: true
    });
  };

  render() {
    const { imgList = [], enlargePic, src } = this.state;
    const { title, maxLength, icon, editable = true, style, className = '' } = this.props;

    return (
      <div>
        <div className={cx('image-picker', className)}>
          {maxLength == 1 ? (
            <div className="content-box">
              <div className="pic">
                <Flex
                  className="pic_content"
                  direction="column"
                  align="center"
                  justify="center"
                  style={style}
                  onClick={() => {
                    if (imgList && imgList[0]) {
                      this.lookPic(imgList[0]);
                    }
                  }}>
                  {icon || <span className="iconfont icon-upload" />}
                  {title && <span className="title">{title}</span>}
                  {imgList && imgList[0] && <img className="pic_url" src={imgList[0]} />}
                  {editable && imgList[0] ? (
                    <span
                      onClick={(e) => {
                        this.onDelete(0);
                        e.stopPropagation();
                        return false;
                      }}
                      className="iconfont icon-reeor"
                    />
                  ) : (
                    ''
                  )}
                  {editable && !imgList[0] ? (
                    <ImagePicker
                      className="img_choose"
                      files={[]}
                      selectable
                      multiple={false}
                      onChange={(files, type, index) => {
                        this.onChange(files, type, index);
                      }}
                      onImageClick={(index, fs) => console.log(index, fs)}
                    />
                  ) : (
                    ''
                  )}
                </Flex>
              </div>
            </div>
          ) : (
            <div className="content-box">
              <div className="pic">
                <Flex className="pic_list_content" wrap="wrap" align="left">
                  {imgList.map((val, idx) => (
                    <div key={idx} className="up_img_list" onClick={() => val && this.lookPic(val)}>
                      <img src={val} />
                      {editable && (
                        <span
                          onClick={() => {
                            this.onDelete(idx);
                          }}
                          className="iconfont icon-reeor"
                        />
                      )}
                    </div>
                  ))}
                  {/* 图片list */}
                  {imgList.length < maxLength && editable ? (
                    <Flex
                      className="pic_content"
                      direction="column"
                      align="center"
                      justify="center"
                      style={style}>
                      {icon || <span className="iconfont icon-upload" />}
                      {title && <span className="title">{title}</span>}
                      <ImagePicker
                        className="img_choose"
                        files={[]}
                        selectable
                        multiple={false}
                        onChange={(files, type, index) => {
                          this.onChange(files, type, index);
                        }}
                        onImageClick={(index, fs) => console.log(index, fs)}
                      />
                    </Flex>
                  ) : (
                    ''
                  )}
                </Flex>
              </div>
            </div>
          )}
        </div>
        {/* 放大图片 */}
        <div
          className={cx('large-pic', enlargePic ? 'show' : '')}
          onClick={() => {
            this.setState({
              src: '',
              enlargePic: false
            });
          }}>
          <img src={src} alt="放大图片" onClick={(e) => e.stopPropagation()} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/ImagePicker/index.js